import { Entry } from 'contentful';
import { TypeProductFields } from '@/core/generated-types';
import { ShopifyVariant } from '@/lib/shopify';
import { SelectedAddOns } from '../ProductAddToCart/ProductAddToCart';
import { formatMoney } from '@/utils/helpers';

export interface ProductAddOnsProps {
  productAddOns?: Entry<TypeProductFields>[];
  selectedAddOns: SelectedAddOns[];
  setSelectedAddOns: (selectedAddOns: SelectedAddOns[]) => void;
  productFields: TypeProductFields;
  defaultVariant: ShopifyVariant;
}

export const calculateCartTotal = (
  defaultVariant: ShopifyVariant,
  selectedAddOns: SelectedAddOns[],
  locale: string,
) => {
  const defaultPrice = Number(defaultVariant.price?.amount ?? 0);

  const cartTotal = selectedAddOns.reduce((acc, selectedAddOn) => {
    const price = Number(selectedAddOn.variant.price?.amount ?? 0);
    return acc + price;
  }, defaultPrice);

  return formatMoney(cartTotal, locale);
};

export const getCartList = (
  productTitle: string,
  selectedAddOns: SelectedAddOns[],
) => {
  const addOnTitles = selectedAddOns
    .map((selectedAddOn) => selectedAddOn.fields.title)
    .join(', ');
  const addOnTitlesList = addOnTitles ? `, ${addOnTitles}` : '';
  return `${productTitle}${addOnTitlesList}`;
};
